import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDeleteWalletMutation } from "../../../../../services/queryHooks";
import { useTranslation } from "react-i18next";

export default function DeleteWalletConfirmationModal({
	walletId,
	walletName,
	type,
	onClose,
}) {
	const { mutate } = useDeleteWalletMutation();
	const handleSubmit = () => {
		mutate({ walletId });
		onClose();
	};
	const { t } = useTranslation();

	const dialogTitle = () => {
		if (type === "cash") {
			return t("deleteCashWalletTitle");
		} else if (type === "asset") {
			return t("deleteAssetWalletTitle");
		} else if (type === "liability") {
			return t("deleteLiabilityWalletTitle");
		}
	};
	const dialogDescription = () => {
		if (type === "cash") {
			return t("deleteCashWalletDescription");
		} else if (type === "asset") {
			return t("deleteAssetWalletDescription");
		} else if (type === "liability") {
			return t("deleteLiabilityWalletDescription");
		}
	};

	return (
		<>
			<Dialog
				disableEnforceFocus
				open={walletId}
				onClose={onClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{dialogTitle()} {walletName}?
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{dialogDescription()}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose}>{t("cancel")}</Button>
					<Button
						variant="contained"
						color="error"
						onClick={handleSubmit}
					>
						{t("delete")}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}
